import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { useAuth, isAdminRole } from "@/lib/auth/AuthContext";

// Session 26: Route-Guard fuer /team — admin + superadmin. Analog zu
// RequireSuperadmin, laesst aber auch admin durch. PL + Buchhaltung fliegen
// auf "/".

export function RequireAdmin({ children }: { children: ReactNode }) {
  const { status, user } = useAuth();
  if (status === "loading") return null;
  if (!user || !isAdminRole(user.role)) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
